<template>
  <div class="page publish-mt">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }"
        >练习中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{from === 'mt' ? '布置同步练习' : '布置高频错题训练'}}</el-breadcrumb-item>
    </el-breadcrumb>
    <card-header class="mt-20 mb-30">{{from === 'mt' ? '布置日常同步练习' : '布置高频错题训练'}}</card-header>
    <div class="hr"></div>
    <el-form class="mt-40" label-width="110px">
      <el-form-item
        label="练习名称："
        required
        :class="errorProp === 'name' ? 'is-error' : ''"
      >
        <el-col :span="6">
          <el-input
            placeholder="请输入练习名称"
            maxlength="30"
            v-model="searchForm.name"
          ></el-input>
        </el-col>
        <el-col
          style="margin-left: 10px; color: rgba(144, 147, 153, 1)"
          :span="10"
          >{{ searchForm.name.length }}/30</el-col
        >
      </el-form-item>
      <el-form-item
        :label="`${from === 'mt' ? '预习': '练习'}知识点
        （${this.knowledgeCount.size}个知识点，${totalCount}道题）：`"
        class="knowledge-count"
      >
        <el-col :span="18">
          <div class="knowledge-name">
            <el-tag
              v-for="(name, index) in knowledgeCount"
              :key="index"
              type="info"
              size="small"
            >
              {{ name }}
            </el-tag>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="练习对象：" required>
        <el-col :span="6">
          <el-cascader
            ref="cascader"
            :options="gradeList"
            style="width: 100%"
            separator=""
            :props="{
              multiple: true,
              value: 'dl_code',
              label: 'name',
              children: 'class_infos',
            }"
            v-model="searchForm.targets"
            popper-class="c-cascader"
            :class="errorProp === 'targets' ? 'is-error' : ''"
            @change="handleChange"

          >
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span
                v-if="!node.isLeaf && getSelectedCount(data.academic_year_id)"
                class="c-cascader__count"
              >
                {{ getSelectedCount(data.academic_year_id) }}
              </span>
            </template>
          </el-cascader>
        </el-col>
      </el-form-item>
      <el-form-item
        label="练习说明："
        required
        :class="errorProp === 'remark' ? 'is-error' : ''"
      >
        <el-col :span="12">
          <el-input
            type="textarea"
            v-model="searchForm.remark"
            placeholder="请输入练习说明"

          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <footer class="p-create__footer mt-40">
      <p
        class="p-create__error"
        :style="{ visibility: errorMessage ? 'visible' : 'hidden' }"
      >
        *{{ errorMessage }}
      </p>
      <el-button class="p-create__button" @click="onCancelClick"
        >取 消</el-button
      >
      <el-button type="primary" class="p-create__button" @click="onCreateClick"
        >确认布置</el-button
      >
    </footer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { createEvaluate, getTeacherClassYear, getLastInfo } from '@/api/pt';
import CardHeader from '@/components/card-header.vue';
import { isScienceArr } from '@/utils';

export default {
  name: 'PublishMt',
  components: {
    CardHeader,
  },
  data() {
    const { from, type } = this.$route.query;
    return {
      from,
      type,
      searchForm: {
        name: '', // 布置练习名称
        // targets: [[7, '627555055683276800'],
        //   ['7', '627864377575399424'],
        //   ['8', '627556300582064128'],
        //   ['8', '627580459106209792']], // 布置班级列表
        targets: '',
        remark: '',
      },
      gradeList: [], // 练习年级列表
      formedTargets: '',
      errorProp: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'knowledgeName',
      'knowledgeCode',
      'questionsBasket',
      'courseInformation',
      'categoryObj',
      'topicList',
      'commonWrongCategoryObj',
    ]),
    category() {
      if (this.from === 'mt') {
        return this.categoryObj;
      }
      return this.commonWrongCategoryObj;
    },
    knowledgeCount() {
      const count = new Set();
      this.knowledgeName.forEach((x) => count.add(x));
      return count;
    },
    questionIds() {
      const list = {};
      this.questionsBasket.forEach((item) => {
        let code;
        let name;
        if (item.knowledge_code) {
          code = item.knowledge_code;
          name = item.knowledge_name;
        } if (item.knowledge_codes && item.knowledge_codes.length > 0) {
          code = item.knowledge_codes[0].tag_code;
          name = item.knowledge_codes[0].tag_name;
        } if (item.title_question
        && item.title_question.knowledge && item.title_question.knowledge.length > 0) {
          code = item.title_question.knowledge[0].tag_code;
          name = item.title_question.knowledge[0].tag_name;
        }
        const node = {
          question_uuid: item.question_uuid,
          question_title_uuid: item.question_title_uuid,
          knowledge_code: code,
          knowledge_name: name,
          estimates_time: item.estimates_time,
          k_module: item.p_k_module || item.k_module,
          k_module_name: item.p_k_module_name || item.k_module_name,
          study_used_type: -1,
        };
        // TODO:knowledge_code 字段 还是 knowledge_codes?
        this.$set(list, item.question_uuid,
          isScienceArr(this.category.subjectId) ? (item.knowledge_code
          || item.knowledge_codes[0].tag_code || item.title_question.knowledge[0].tag_code) : node);
      });
      return list;
    },
    errorMessage() {
      const map = {
        name: '请输入练习名称',
        remark: '请输入练习说明',
        targets: '请选择测评对象',
      };
      return `${map[this.errorProp] || ''}`;
    },
    placeholderInfo() {
      const myDate = new Date();
      let tMonth = myDate.getMonth() + 1;
      let tDay = myDate.getDate();
      tMonth = tMonth < 10 ? `0${tMonth}` : tMonth;
      tDay = tDay < 10 ? `0${tDay}` : tDay;
      const time = `${tMonth}${tDay}`;
      const name = `${time}${this.category.subjectName}${this.from === 'mt' ? '同步练习' : '高频错题训练'}`;
      return name;
    },
    totalCount() {
      let count = 0;
      this.questionsBasket
        .forEach((item) => {
          if (item.child_question_num > 0) {
            count += item.child_question_num;
          } else {
            count += 1;
          }
        });
      return count;
    },
    totalTime() {
      let time = 0;
      if (this.type === 'again') {
        this.uniqObj(this.questionsBasket).forEach((item) => {
        // time += item.teacher_estimates_time;
          if (item.question_title_uuid === '') {
          // 文理科单选多选:30s
            if (item.question_type === 1 || item.question_type === 2) {
              time += 30;
              // 判断题:30s
            } else if (item.question_type === 3 && item.show_type === '103') {
              time += 30;
              // 填空题,选词填空题:60s
            } else {
              time += 60;
            }
          } else {
            time += 180;
          }
        });
      } else {
        this.questionsBasket.forEach((item) => {
        // time += item.teacher_estimates_time;
          if (item.question_title_uuid === '') {
          // 文理科单选多选:30s
            if (item.question_type === 1 || item.question_type === 2) {
              time += 30;
              // 判断题:30s
            } else if (item.question_type === 3 && item.show_type === '103') {
              time += 30;
              // 填空题,选词填空题:60s
            } else {
              time += 60;
            }
          } else {
            time += 180;
          }
        });
      }

      return Math.ceil(time / 60);
    },
    remarkInfo() {
      const name = `本次练习共${this.totalCount}题，预计用时${this.totalTime}分钟`;
      return name;
    },
  },
  watch: {
    // 'searchForm.targets': function refinedTargets(v) {
    //   if (!v) {
    //     return;
    //   }
    //   this.$nextTick(() => {
    //     this.formedTargets = this.$refs.cascader
    //     && this.$refs.cascader.checkedNodes.map((item) => ({
    //       grade_id: item.path[0],
    //       class_id: item.path[1],
    //       class_name: item.pathLabels[1],
    //       school_year: item.pathLabels[0],
    //     }));
    //   });
    // },
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.formedTargets = this.$refs.cascader.checkedNodes.map((item) => ({
          grade_id: item.path[0],
          class_id: item.path[1],
          class_name: item.pathLabels[1],
          school_year: item.pathLabels[0],
        }));
      });
    },
    // 查询最后一次作业的班级信息
    async queryLastInfo() {
      await getLastInfo({
        type: 3,
      }).then((res) => {
        if (res.code === 200) {
          // this.queryLastData = res.data;
          if (res.data.evaluate_object.length > 0) {
            const classList = [];
            res.data.evaluate_object.forEach((item) => {
              classList.push([String(item.grade_id), String(item.class_id)]);
            });
            this.searchForm.targets = classList;
            this.formedTargets = res.data.evaluate_object.map((item) => ({
              grade_id: item.grade_id,
              class_id: item.class_id,
              class_name: item.class_name,
              school_year: item.school_year,
            }));
          }
        }
      });
    },
    getTeacherClassYear() {
      return getTeacherClassYear().then((res) => {
        if (res.code === 200) {
          this.gradeList = res.data;
          const classList = [];
          console.log(333333333);
          if (this.categoryObj.lastClassList) {
            this.categoryObj.lastClassList.forEach((item) => {
              classList.push([String(item.grade_id), String(item.class_id)]);
            });
          }
          // 将lastinfo班级信息赋值
          this.searchForm.targets = classList;
        }
      });
    },
    getSelectedCount(id) {
      if (!this.searchForm.targets) {
        return 0;
      }
      const len = this.$refs.cascader && this.$refs.cascader.checkedNodes
        .filter((item) => item.pathNodes[0].data.academic_year_id === id).length;
      return len;
    },
    onCancelClick() {
      this.$router.go(-1);
    },
    onCreateClick() {
      if (this.loading) {
        return;
      }
      if (this.checkForm()) {
        this.errorProp = '';
        this.loading = true;
        createEvaluate({
          evaluate_name: this.searchForm.name,
          remark: this.searchForm.remark,
          subject_id: this.category.subjectId,
          textbook_id: this.category.textbookId,
          test_grade_id: this.category.gradeId,
          course_id: this.courseInformation.courseId,
          course_name: this.courseInformation.courseName,
          app_id: 3,
          type: 3,
          is_sync: 1,
          evaluate_object: JSON.stringify(this.formedTargets),
          question_ids: JSON.stringify({
            knowledge_codes: this.knowledgeCode,
            question_ids: this.questionIds,
          }),
          source_type: this.from === 'mt' ? 1 : 2, // 正常布置1，错题2
        }).then((res) => {
          if (res.code === 200) {
            console.log('创建成功');
            this.$router.push({
              path: '/pt/publish-success',
            });
          } else {
            this.$message({
              type: 'warning',
              message: res.msg,
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$message({
            type: 'warning',
            message: e.msg,
          });
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    checkForm() {
      const keys = Object.keys(this.searchForm);
      return keys.every((key) => {
        if (this.searchForm[key]) {
          return true;
        }
        this.errorProp = key;
        return false;
      });
    },
    // 对象去重
    uniqObj(arrList) {
      const dataArr = [];
      const dataObj = {};
      for (let i = 0; i < arrList.length; i += 1) {
        const item = arrList[i].question_title_uuid;
        if (item !== '') {
          if (!dataObj[item]) {
            dataArr.push(arrList[i]);
            dataObj[item] = true;
          }
        } else {
          dataArr.push(arrList[i]);
        }
      }
      return dataArr;
    },
  },
  activated() {
    this.getTeacherClassYear();
    this.searchForm.name = this.placeholderInfo;
    this.searchForm.remark = this.remarkInfo;
    // 查询最后一次作业的班级信息
    this.queryLastInfo();
  },

  mounted() {
    this.getTeacherClassYear();
    this.searchForm.name = this.placeholderInfo;
    this.searchForm.remark = this.remarkInfo;
    // 查询最后一次作业的班级信息
    this.queryLastInfo();
  },
};
</script>
<style lang="scss" scoped>
.knowledge-count /deep/ .el-form-item__label {
  float: none;
  padding: 0 12px 0 18px;
}
.knowledge-name {
  width: 793px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 5px 12px 13px 0;
}
.knowledge-name /deep/ .el-tag {
  color: #5a5e66;
  background: #f0f2f5;
  margin-left: 12px;
  margin-top: 8px;
}
.p-create__error {
  color: rgba(245, 108, 108, 1);
  font-size: 14px;
  line-height: 2;
}
.p-create__footer {
  padding-left: 110px;
}
.p-create__button {
  width: 120px;
}
/deep/ .is-error .el-input__inner {
  border: 1px solid #f56c6c;
}
</style>
